import { useEffect } from 'react'
import { useEditorRef, useEditorSelector } from '@udecode/plate-common/react'
import { SECOND_MS } from 'data/constants'
import { useThrottledValue } from 'hooks/useThrottledValue'
import { useInputStore } from 'store/store'

import { toMD } from '../utils/toMD'
import { toPlainText } from '../utils/toPlainText'

type Props = {
    storageId?: string
}

export const RememberInputPlugin = (props: Props) => {
    const { storageId } = props
    const setInput = useInputStore((state) => state.setChannelmessageInput)

    const editor = useEditorRef()
    const children = useThrottledValue(
        useEditorSelector((_editor) => toPlainText(_editor.children), []),
        SECOND_MS,
    )

    useEffect(() => {
        if (!storageId || editor.history.undos.length === 0) {
            return
        }
        toMD(editor).then((markdownMessage) => {
            setInput(storageId, markdownMessage.message)
        })
    }, [children, editor, setInput, storageId])

    return null
}
